<template>
	<div class="school-manage" style="padding: 20px">
		<!-- 搜索 + 按钮区域 -->
		<div style="margin-bottom: 15px; display: flex; gap: 10px; align-items: center">
			<el-input v-model="queryName" placeholder="学校名称" style="width: 200px" clearable />

			<!-- 上级教育局 远程搜索 -->
			<el-select v-model="queryEduId" placeholder="所属教育局" style="width: 250px" remote reserve-keyword
				:remote-method="remoteSearchEdu" filterable clearable>
				<el-option v-for="item in eduList" :key="item.id" :label="item.eduName" :value="item.id" />
			</el-select>

			<el-button type="primary" @click="getList">搜索</el-button>
			<el-button @click="resetQuery">重置</el-button>
			<el-button type="primary" @click="openAdd">新增学校</el-button>
		</div>

		<!-- 表格 -->
		<el-table border :data="schoolList" size="small" v-loading="loading">
			<el-table-column prop="id" label="ID" width="80" />
			<el-table-column prop="schoolName" label="学校名称" />
			<el-table-column prop="shortName" label="简称" />
			<el-table-column prop="eduName" label="所属教育局" />
			<el-table-column prop="schoolUser.username" label="登陆账号" />
			<!-- 学段 多选展示 -->
			<el-table-column label="学段">
				<template slot-scope="scope">
					{{forName(scope.row.stages)}}
				</template>
			</el-table-column>

			<el-table-column prop="startDate" label="起始日期" width="120" />
			<el-table-column prop="address" label="地址" min-width="200" />
			<el-table-column prop="contact" label="联系人" width="100" />
			<el-table-column prop="phone" label="联系电话" width="130" />
			<el-table-column prop="status" label="状态" width="90" :formatter="(r) => r.status === 0 ? '正常' : '禁用'" />
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
					<el-button size="mini" type="danger" @click="delSchool(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="getList" @current-change="getList" :current-page="pageNum" :page-sizes="[10]"
			:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"
			style="margin-top: 15px; text-align: right;">
		</el-pagination>

		<!-- 新增/编辑 弹窗 -->
		<el-dialog :title="isEdit ? '编辑学校' : '新增学校'" :visible.sync="dialogVisible" width="700px" destroy-on-close center>
			<el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
				<el-form-item label="学校名称" prop="schoolName">
					<el-input v-model="form.schoolName" style="width: 400px" />
				</el-form-item>
				<el-form-item label="简称" prop="shortName">
					<el-input v-model="form.shortName" style="width: 400px" />
				</el-form-item>


				<!-- 上级教育局 远程搜索 -->
				<el-form-item label="所属教育局" prop="eduId">
					<el-select v-model="form.eduId" style="width: 400px" remote reserve-keyword
						:remote-method="remoteSearchEdu" filterable>
						<el-option v-for="item in eduList" :key="item.id" :label="item.eduName" :value="item.id" />
					</el-select>
				</el-form-item>

				<!-- 学段 多选 -->
				<el-form-item label="学段" prop="stages">
					<el-select v-model="form.stages" multiple placeholder="请选择学段" style="width: 400px"
						:tag-closable="false" 
						@change="handleStageChange"
						>
						<el-option v-for="item in stages" :key="item.value" :label="item.label" :value="item.value"
							disabled />
						<el-option v-for="item in stageOptions" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-form-item>

				<!-- 起始日期 -->
				<el-form-item label="起始日期" prop="startDate">
					<el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
				</el-form-item>

				<el-form-item label="省份">
					<el-select v-model="form.province" @change="getCities" placeholder="请选择省" filterable>
						<el-option v-for="p in provinceList" :key="p.id" :label="p.name" :value="p.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="城市">
					<el-select v-model="form.city" @change="getAreas" placeholder="请选择市" filterable
						:disabled="cityList.length==0">
						<el-option v-for="c in cityList" :key="c.id" :label="c.name" :value="c.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="区县">
					<el-select v-model="form.area" placeholder="请选择区县" filterable :disabled="areaList.length==0">
						<el-option v-for="a in areaList" :key="a.id" :label="a.name" :value="a.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="详细地址" prop="address">
					<el-input v-model="form.address" style="width: 400px" />
				</el-form-item>
				<el-form-item label="联系人" prop="contact">
					<el-input v-model="form.contact" style="width: 400px" />
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="form.phone" style="width: 400px" />
				</el-form-item>
			</el-form>

			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm">确认保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		forEduName,
		getRegion
	} from "@/js/standard.js";

	export default {
		name: "SchoolManage",
		data() {
			return {
				loading: false,
				schoolList: [],
				total: 0, // 总条数
				pageNum: 1, // 当前页
				pageSize: 10, // 每页条数
				queryName: "",
				queryEduId: "",

				eduList: [],
				dialogVisible: false,
				isEdit: false,
				formRef: "formRef",
				allStageOptions: [{
						label: '小学',
						value: '1'
					},
					{
						label: '初中',
						value: '2'
					},
					{
						label: '高中',
						value: '3'
					},
					{
						label: '中职',
						value: '4'
					},
				],
				form: {
					id: null,
					schoolName: "",
					shortName: "",
					province: "",
					city: "",
					area: "",
					address: "",
					contact: "",
					phone: "",
					eduId: "",
					stages: [],
					startDate: "",
					status: 0,
				},
				rules: {
					schoolName: [{
						required: true,
						message: "请输入学校名称",
						trigger: "blur"
					}],
					eduId: [{
						required: true,
						message: "请选择教育局",
						trigger: "change"
					}],
				},
				provinceList: [],
				cityList: [],
				areaList: [],
				stages: [],
				login:null,
				eduLists:{},
			};
		},
		created() {
			this.getProvinces();
			this.getList();
		},
		computed: {
			// 可选学段 = 全部学段 - 旧学段（自动过滤，不重复）
			stageOptions() {
				return this.allStageOptions.filter(
					(item) => !this.form.stages.includes(item.value)
				);
			},
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			  handleStageChange(newArr){
			    // 原有旧学段数组
			    const oldValArr = this.stages.map(o=>o.value);
			    // 筛选：被删掉的原有学段
			    const delOld = oldValArr.filter(v=>!newArr.includes(v));
			    if(delOld.length>0){
			      // 把删掉的旧学段强制加回去
			      this.form.stages = [...new Set([...newArr,...oldValArr])];
			    }
			  },
			  // 编辑回显不变
			  getSchoolDetail(id){
			    schoolApi.detail(id).then(res=>{
			      this.form = {...res.data};
			      this.form.stages = this.form.stages ? this.form.stages.split(',') : [];
			      this.stages = this.allStageOptions.filter(it=>this.form.stages.includes(it.value));
			    })
			  },
			forName(str) {
				if (!str || str == '') return '未定义'
				let type = []
				if (str.length > 1) {
					type = str.split(',')
				} else {
					type[0] = str
				}
				type = type.sort((a, b) => Number(a) - Number(b))
				let name = ''
				for (let i = 0; i < type.length; i++) {
					var t = type[i]
					var n = t == 1 ? '小学' : t == 2 ? '初中' : t == 3 ? '高中' : t == 4 ? '职高' : '未定义'
					if (i == 0) {
						name = n
					} else {
						name = `${name}|${n}`
					}
				}
				return name
			},
			// ====================== 分页加载列表 ======================
			async getList(val) {
				if(val){
					this.pageNum=val
				}
				this.loading = true;
				const params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					// schoolName: this.queryName,
					// eduId: this.queryEduId,
				};
				const res = await this.API.get(this.API.admin.getSchoolList, {
					...params
				});
				this.schoolList = res.data.data.records;
				this.total = res.data.data.total;
				this.loading = false;
			},

			// ====================== 远程搜索教育局 ======================
			async remoteSearchEdu(keyword) {
				if (!keyword) {
					this.eduList = [];
					return;
				}
				const res = await forEduName(this, keyword);
				if(this.eduLists){
					if(res.filter(v=>v.id==this.eduLists?.id).length>0){
						this.eduList=res
					}else{
						this.eduList = [this.eduLists,...res]
					}
					
				}else{
					this.eduList=res
				}
				
			},

			// ====================== 新增 ======================
			openAdd() {
				this.stages = []
				this.isEdit = false;
				this.form = {
					id: null,
					schoolName: "",
					shortName: "",
					province: "",
					city: "",
					area: "",
					address: "",
					contact: "",
					phone: "",
					eduId: "",
					stages: [],
					startDate: "",
					status: 0
				};
				this.dialogVisible = true;
			},
			async getEduId(id){
				try {
					let res=this.API.get(this.API.admin.getEduId+id)
					
					return res
				}catch(err){
					return []
				}
			},
			// ====================== 编辑 ======================
			async openEdit(row) {
				this.stages = []
				this.isEdit = true;
				this.form = {
					...row
				};
				console.log('this.form',this.form)
				this.form.province=Number(this.form.province)
				this.form.city=Number(this.form.city)
				this.form.area=Number(this.form.area)
				if (this.form.stages) {
					this.form.stages = this.form.stages.split(",");
					this.stages = this.allStageOptions.filter(item =>
						this.form.stages.includes(item.value)
					);
				}
				let eduarr=await this.getEduId(row.eduId)
				this.eduLists=eduarr.data.data
				this.eduList=[this.eduLists]
				await this.getCities(this.form.province, true);
				await this.getAreas(this.form.city, true);
				this.dialogVisible = true;
			},

			// ====================== 提交保存 ======================
			async submitForm() {
				try{
					await this.$refs.formRef.validate();
					const params = {
						...this.form,
						stages: this.form.stages.join(","),
					};
					
					if (this.isEdit) {
						this.loginOpen('修改中...')
						await this.API.put(this.API.admin.putSchoolUpdate, params);
					} else {
						this.loginOpen('新增学校中...')
						await this.API.post(this.API.admin.postSchoolAdd, params);
					}
					this.$message.success("保存成功");
					this.dialogVisible = false;
					this.getList();
				}catch(err){
					this.noLogin()
				}finally{
					this.noLogin()
				}
			},

			// ====================== 删除 ======================
			async delSchool(id) {
				await this.$confirm("确定删除？");
				await this.API.del(this.API.admin.delSchool + id);
				this.$message.success("删除成功");
				this.getList();
			},

			// ====================== 地区 ======================
			async getProvinces() {
				if (this.provinceList.length === 0) {
					this.provinceList = await getRegion(this, 1, 1);
				}
			},
			async getRegionList(level, id) {
				const list = await getRegion(this, level, id);
				if (level === 1) this.provinceList = list;
				if (level === 2) this.cityList = list;
				if (level === 3) this.areaList = list;
			},
			getCities(id, status) {
				if (!status) {
					this.form.city = "";
					this.form.area = "";
					this.cityList = [];
					this.areaList = [];
				}
				this.getRegionList(2, id);
			},
			getAreas(id, status) {
				if (!status) {
					this.form.area = "";
					this.areaList = [];
				}
				this.getRegionList(3, id);
			},

			// 重置
			resetQuery() {
				this.queryName = "";
				this.queryEduId = "";
				this.pageNum = 1;
				this.getList();
			},
		},
	};
</script>

<style scoped>
	.school-manage {
		width: 100%;
		box-sizing: border-box;
	}
</style>